<template>
  <button
    class="relative flex h-36 w-48 cursor-pointer flex-col justify-center space-y-2 rounded-lg border-2 border-neutral-99 hover:border-primary-80 focus:border-primary-80 focus:outline-none"
  >
    <PlusIcon class="mx-auto h-6 w-6 text-neutral-70" />
    <SimpleButton tabindex="-1" theme="primary-light" class="pointer-events-none mx-auto">
      {{ t("addFontButton") }}
    </SimpleButton>
  </button>
</template>

<script lang="ts" setup>
// Components
import SimpleButton from "@/vue/components/atoms/SimpleButton.vue";

// Icons
import { PlusIcon } from "@heroicons/vue/outline";

//Utils
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<i18n lang="jsonc">
{
  "es": {
    "addFontButton": "Agregar fuente"
  },
  "pt": {
    "addFontButton": "Adicionar fonte"
  }
}
</i18n>
